import { ResponseGetAssigns } from '@vindr/services/apis/assign.api';
import { Modal, Typography } from 'antd';
import { MessageInstance } from 'antd/es/message/interface';
import { useTranslation } from 'react-i18next';
import AssignedEditForm from './AssignedEditForm';
const { Title } = Typography;

const EditAssign = ({
  assignData,
  isEditing,
  onFinish,
  message,
}: {
  assignData: ResponseGetAssigns['data']['0'];
  isEditing: boolean;
  onFinish: () => void;
  message: MessageInstance;
}) => {
  const { t } = useTranslation('Vindoc');

  return (
    <Modal
      className="vindr-modal add-order max-w-screen w-[900px]"
      title={false}
      open={isEditing}
      maskClosable={false}
      destroyOnClose
      zIndex={1001}
      onCancel={onFinish}
      footer={null}
    >
      <Title level={3} className="mb-6">
        {t('Edit Assign Radiologist')}
      </Title>
      <AssignedEditForm assign={assignData} onFinish={onFinish} message={message} />
    </Modal>
  );
};

export default EditAssign;
